import React, {useEffect} from 'react'
import {Stack, Divider, Grid} from '@mui/material'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'

export default function CheckInSurveyBlock({checkin}) {
  return (
    <Grid container spacing={1}>
      {checkin?.checkInSurveys.map((survey, index) => (
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <div className="checkin-survey-block">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <div className="surveyname">{survey.name}</div>
            </Stack>
            <Divider orientation="horizontal" />
            <Stack direction="column" mt={2} rowGap={1}>
              <div className="total-students">
                <PersonOutlineOutlinedIcon sx={{fontSize: '20px'}} />
                <div>
                  Total Questions: <strong>{survey.questionCount}</strong>
                </div>
              </div>
            </Stack>
          </div>
        </Grid>
      ))}
    </Grid>
  )
}
